export default "__VITE_ASSET__BCQPMdOP__"